import { render, staticRenderFns } from "./AuthorForm.vue?vue&type=template&id=59e86ab8"
import script from "./AuthorForm.vue?vue&type=script&lang=js"
export * from "./AuthorForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports